export default __webpack_public_path__ + "static/media/asset2.272c3b8f.png";